<script lang="ts">
	import type { Device } from 'src/types/Device';
	import VideoContainer from '../../CameraPlayer/VideoContainer.svelte';
	import WebRTCPlayer from '../../CameraPlayer/WebRTCPlayer.svelte';

	export let device: Device;
</script>

<div class="mb-s">
	<VideoContainer isZoomable={false}>
		<WebRTCPlayer deviceId={device.id} showControls={false} previewSize="medium" />
	</VideoContainer>
</div>
